// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"56":"c4f15293d4415bda763c","254":"392d20a72653b226c137","318":"0dfd0500be46d9a162a7","393":"9b69e7dd8607bca25b1e","540":"6311a5fd9126718dcf7d","848":"e85ea53e0c435814c171","961":"d11f14278a05cf6bc363"}[chunkId] + ".js";
};